<div>
  <img src="assets/images/nodata.svg"/>
</div>